module.exports = __webpack_public_path__ + "static/media/windmill.d2927ee2.jpg";